// src/components/public/data/FAQ.js
// Updated FAQ for ARAMA Pricing Intelligence

const faqs = [
    {
      id: 1,
      slug: "getting-started",
      question: "How do I get started?",
      answer:
        "Due to high demand, we have opened up a waitlist as we scale up our systems to address this demand. Please fill out the form from the home or pricing page and we will get back to you as soon as possible."
    },
    {
      id: 2,
      slug: "data-requirements",
      question: "What data does ARAMA need?",
      answer:
        "Just your order history, current inventory, and any past promo prices. We do not collect customer names, emails, or payment details."
    },
    {
      id: 3,
      slug: "price-change-control",
      question: "Will ARAMA change my prices automatically?",
      answer:
        "You stay in control. We send price cards with a predicted margin lift; you click Approve or Dismiss."
    },
    {
      id: 4,
      slug: "data-security",
      question: "Where is my data stored and how secure is it?",
      answer:
        "All data is encrypted in transit and at rest on EU-based servers. We never sell or share your raw data with third parties, period."
    },
    {
      id: 5,
      slug: "platform-compatibility",
      question: "Does ARAMA work only with Shopify?",
      answer:
        "CSV import works for any platform. Coming next: direct connectors for WooCommerce and BigCommerce. Tell us if you want early access."
    },
    {
      id: 6,
      slug: "technical-expertise",
      question: "Do I need technical expertise?",
      answer:
        "If you can download a spreadsheet, you can use ARAMA. Everything else is handled for you."
    },
    {
      id: 7,
      slug: "results-timeline",
      question: "How quickly will I see results?",
      answer:
        "Most stores see the first winning test within 2–3 weeks, once ARAMA learns your demand curve."
    },
    {
      id: 8,
      slug: "cancellation-policy",
      question: "Can I cancel any time?",
      answer:
        "Yes. ARAMA is month-to-month. Export your data, turn off price cards, and you’re done—no lock-in."
    }
  ];
  
  export default faqs;
  